import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fcfcad4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "viewer-part-search",
  "data-unit": "viewer-part-search"
}
const _hoisted_2 = { class: "field has-addons" }
const _hoisted_3 = { class: "control is-expanded has-icons-left has-icons-right" }
const _hoisted_4 = ["aria-activedescendant", "aria-expanded", "aria-label", "disabled", "placeholder", "onKeydown"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon is-small is-left fas fa-search",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon is-small fas fa-times",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "button is-static result-count",
  "data-unit": "viewer-part-search-count",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon is-small fas fa-chevron-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["aria-label"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon is-small fas fa-chevron-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "help",
  "data-unit": "viewer-part-search-unavailable",
  role: "status"
}
const _hoisted_17 = {
  key: 1,
  class: "viewer-part-search-empty",
  "data-unit": "viewer-part-search-empty",
  role: "status"
}
const _hoisted_18 = {
  key: 2,
  id: "viewer-part-search-results",
  class: "viewer-part-results menu-list",
  "data-unit": "viewer-part-search-results",
  role: "listbox"
}
const _hoisted_19 = ["id", "aria-selected", "onClick"]
const _hoisted_20 = {
  key: 0,
  class: "part-number"
}
const _hoisted_21 = { class: "part-name" }

import { computed, ref, watch } from 'vue'
import { filterThreeDViewerParts } from '@/helpers/threeDViewerPartSearch'
import type {
  ThreeDViewerPartSearchResult,
  ThreeDViewerPartSearchSource
} from '@/interfaces/library'


export default /*#__PURE__*/_defineComponent({
  __name: 'ThreeDViewerPartSearch',
  props: {
    available: { type: Boolean },
    snapshotName: {},
    source: { default: () => [] }
  },
  emits: ["clearFocus", "focus"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const query = ref('')
const selectedIndex = ref(-1)
const selectedResultKey = ref<string | null>(null)
const results = computed(() => filterThreeDViewerParts(props.source, query.value))
const canNavigate = computed(() => results.value.length > 1)

function handleQueryChange (forceFocus = false) {
  const singleResult = results.value.length === 1 ? results.value[0] : null
  if (!forceFocus && singleResult?.key === selectedResultKey.value) {
    selectedIndex.value = 0
    return
  }

  clearResultSelection()
  emit('clearFocus')
  if (singleResult) selectResult(0)
}

function selectResult (index: number) {
  const result = results.value[index]
  if (!result) return

  selectedIndex.value = index
  selectedResultKey.value = result.key
  emit('focus', result)
}

function selectNext () {
  if (!canNavigate.value) return
  selectResult(selectedIndex.value < 0 ? 0 : (selectedIndex.value + 1) % results.value.length)
}

function selectPrevious () {
  if (!canNavigate.value) return
  selectResult(selectedIndex.value < 0
    ? results.value.length - 1
    : (selectedIndex.value - 1 + results.value.length) % results.value.length
  )
}

function clear () {
  query.value = ''
  clearResultSelection()
  emit('clearFocus')
}

function clearResultSelection () {
  selectedIndex.value = -1
  selectedResultKey.value = null
}

function setQuery (value: string) {
  query.value = value
  handleQueryChange()
}

watch(() => props.source, () => {
  if (query.value) handleQueryChange(true)
})

__expose({ clear, clearResultSelection, setQuery })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
          class: "input is-primary",
          "data-unit": "viewer-part-search-input",
          type: "search",
          autocomplete: "off",
          role: "combobox",
          "aria-autocomplete": "list",
          "aria-controls": "viewer-part-search-results",
          "aria-activedescendant": selectedIndex.value >= 0 ? `viewer-part-search-result-${selectedIndex.value}` : undefined,
          "aria-expanded": query.value.length > 0 && results.value.length > 0,
          "aria-label": _ctx.$t('searchInContent', { contentName: _ctx.snapshotName }),
          disabled: !_ctx.available,
          placeholder: _ctx.$t('searchInContent', { contentName: _ctx.snapshotName }),
          onInput: _cache[1] || (_cache[1] = ($event: any) => (handleQueryChange())),
          onKeydown: [
            _withKeys(_withModifiers(selectNext, ["prevent"]), ["down"]),
            _withKeys(_withModifiers(selectPrevious, ["prevent"]), ["up"])
          ]
        }, null, 40, _hoisted_4), [
          [_vModelText, query.value]
        ]),
        _hoisted_5,
        (query.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button is-white clear-search",
              "data-unit": "clear-viewer-part-search",
              type: "button",
              "aria-label": _ctx.$t('clearSearch'),
              onClick: clear
            }, _hoisted_8, 8, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      (query.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(results.value.length), 1))
        : _createCommentVNode("", true),
      (canNavigate.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "button",
            "data-unit": "previous-viewer-part-result",
            type: "button",
            "aria-label": _ctx.$t('threeD.previousResult'),
            onClick: selectPrevious
          }, _hoisted_12, 8, _hoisted_10))
        : _createCommentVNode("", true),
      (canNavigate.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "button",
            "data-unit": "next-viewer-part-result",
            type: "button",
            "aria-label": _ctx.$t('threeD.nextResult'),
            onClick: selectNext
          }, _hoisted_15, 8, _hoisted_13))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.available)
      ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t('threeD.partInformationUnavailableHelp')), 1))
      : (query.value && results.value.length === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.$t('noSearchResultsHelpText')), 1))
        : (query.value && results.value.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (result, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: result.key
                }, [
                  _createElementVNode("button", {
                    id: `viewer-part-search-result-${index}`,
                    class: _normalizeClass(["button is-white viewer-part-result", { 'is-active': index === selectedIndex.value }]),
                    type: "button",
                    role: "option",
                    "aria-selected": index === selectedIndex.value,
                    onClick: ($event: any) => (selectResult(index))
                  }, [
                    (result.part.visible !== false &&
              result.part.partNumberVisible !== false &&
              result.part.partNumber)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(result.part.partNumber), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(result.part.name), 1)
                  ], 10, _hoisted_19)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
  ]))
}
}

})